var map = {
	"./ace_of_pentacles.png": 1003,
	"./eight_of_pentacles.png": 1004,
	"./five_of_pentacles.png": 1005,
	"./four_of_pentacles.png": 1006,
	"./king_of_pentacles.png": 1007,
	"./knight_of_pentacles.png": 1008,
	"./nine_of_pentacles.png": 1009,
	"./page_of_pentacles.png": 1010,
	"./queen_of_pentacles.png": 1011,
	"./seven_of_pentacles.png": 1012,
	"./six_of_pentacles.png": 1013,
	"./ten_of_pentacles.png": 1014,
	"./three_of_pentacles.png": 1015,
	"./two_of_pentacles.png": 1016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1002;